import $ from 'jquery';

export default function Branch(vm) {
    this.all = function(params) {
        var url = '/branch/list?' + $.param(params);

        return vm.get(url);
    };

    this.create = function(params) {
        var url = '/branch/create';

        return vm.post(url, params);
    };

    this.get = function(id) {
        var url = '/branch/detail/' + id;

        return vm.get(url);
    };

    this.delete = function(params) {
        var url = null;

        if (params.is_permanent == 1)
            url = '/branch/force-delete/' + params.id;
        else
            url = '/branch/delete/' + params.id;

        return vm.delete(url);
    };

    this.restore = function(id) {
        var url = '/branch/restore/' + id;

        return vm.get(url);
    };

    this.summary = function(params) {
        var url = '/branch/summary?' + $.param(params);

        return vm.get(url);
    };
}